export default "__VITE_ASSET__DIjXRGmF__"